module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062258236_Contents#r_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On Monday, I went to the tropical disease doctor down at Bellevue Hospital to check on my progress. I rode the subway downtown listening to the Walkman my parents gave me for Christmas, and the cassette tapes Kip had made for me, the Waitresses and the Au Pairs. The lines at the parasitology department went out the door and out into the hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I signed in on a chart and waited for my name to be called. Many of the patients were African immigrants (an influx of which caused the long lines), including a teenager next to me who said he was from Zaire, and I felt at home among them, more so anyway than with your average New Yorker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The doctor was a handsome, curly-haired guy in his early thirties and had traveled everywhere it seemed. He’d had malaria twice, he told me, dysentery three times, and dengue fever once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s the worst,” he said. “What were you doing down there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Peace Corps.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wish I’d done that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m going back in a few weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("“Let’s see how your recovery goes,” he said. “So let me guess, I’m betting you stopped the chloroquine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And then the fever comes on very suddenly, am I right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The night the fever kicked in, I was drenched with sweat, and went from hot to freezing cold, and then violently thirsty. Then I was extremely dizzy, as though the hut was spinning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you’re from there, it isn’t a big deal, but the first time you get it, it is. Now there are a lot of benign kinds. Yours was the deadly sort. And it’s true, Anton, you came close.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How are you about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not easy to experience something like that. It’s a complicated thing psychologically to recover from, a near death experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve had some recurring nightmares.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not surprised. Are they like your hallucinations?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. I also had a dream I’d died and I was at my own funeral. And everyone was telling me I should go up and say something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wrote a couple of lines in his notepad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You might want to find someone you can talk to about this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A psychologist, I mean. I would. I have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He went on, “I’m going to test you for a few other things—dengue fever, African sleeping sickness.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told him about the dysentery, and how humiliating it was to need to shit so often for such a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at me sympathetically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My first trip to Africa I remember shitting in my pants—right there in my pajamas. That had never happened to me, and "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("my supreme wish is that it will never happen again. I remember waking up with shit all over me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tested my hearing for tinnitus and my muscles for neurological abnormalities. My lower right leg felt often like it had fallen asleep. He said that would get better over time but to check back with him if it persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He said relapses weren’t uncommon even six months out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How will I know if I have one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You won’t. Not right away. But if you’re yellow and puffy and dehydrated and then drenched with sweat in the middle of the night, you get yourself back down here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s a plan,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He walked out of the room. I wondered for a moment if I should become a parasitologist. That’s how rudderless I was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he returned, he said, “I just saw your address on your chart. Your father isn’t Buddy Winter, is he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He is indeed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell him I miss his show, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "spacebreak"
  }, [_c('span', {
    staticClass: "smallcaps_bold"
  }, [_vm._v("THE LIGHT WAS GONE FROM THE DAY. THE DAYS WERE SO SHORT. THE ")]), _vm._v("snow was filthy and the birds looked cold. There were twigs in the ice. It smelled cold and dirty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took the subway home from the clinic, the R, and then the uptown No. 2. The subway was covered in graffiti, crude black Magic Marker stuff on the seats and windows, and the doors. The stations themselves were old and cramped and poorly ventilated, with formerly bright blue columns filthy with grime.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man next to me was talking to himself. He had clearly peed his pants, and was complaining about a woman who’d taken his money and needed to give it back if she goddamn expected to see him again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two guys around my age in red berets stepped aboard, one "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("wearing an army jacket, the other in a white thermal underwear top. They were Guardian Angels, a group that started while I was away with the mission to prevent rapes, assaults, and muggings on the subway. They’d begun with thirteen (the Magnificent 13, they’d called themselves), and now they were over four hundred. They traveled in teams of eight or so and fanned out to different cars.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Good afternoon,” the guy in the army jacket said to the car full of passengers. “I’m Joseph and this is Hector, and we’re here to make your ride home safe and enjoyable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now that he was closer to me, I could see they were younger than I’d guessed—seventeen or eighteen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two years back I had my life threatened on a Brooklyn-bound No. 2 train for making eye contact with a man with a mangled ear. “The fuck you looking at?” he said, and when I said, “Nothing,” he pressed his face so close to mine I could see inside his pores, and said, “Damn right, nothing, I will "), _c('i', [_vm._v("kill")]), _vm._v(" you, motherfucker.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For what?” I actually said aloud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smacked the book I’d been reading onto the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('i', [_vm._v("Dead")]), _vm._v(" man,” he said, his eyes wild with rage, and after a chilling ten seconds of staring he walked away, and glared at other passengers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("New York felt more on edge than any place I saw in Africa, or anywhere else on my travels. When I left for any length of time, I always forgot how stressful it could feel just getting around at certain hours and on particular streets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In middle school we heard stories about a guy named Charlie Chop-off, one of those urban legends based on someone real. Boys were dragged into alleyways or dark hallways to be stabbed and in some cases raped, and then their genitals removed with a switchblade. We all had nightmares about Charlie Chop-off. And in the playground we’d joke as someone left for his home "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("in the dwindling light, "), _c('i', [_vm._v("Watch out for Charlie Chop-off")]), _vm._v(". Or at a friend’s house you’d pull a knife from the kitchen drawer, stare at your friend’s crotch, and shout, "), _c('i', [_vm._v("It’s Charlie Chop-off!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At least seven kids fell victim to Charlie, maybe close to twenty. Then there was the Son of Sam, who did his work in the other boroughs but could have stricken anywhere, and Calvin Jackson in our neighborhood who killed and raped women and stole their household appliances. (When caught, he said he “"), _c('i', [_vm._v("liked")]), _vm._v(" killing.”)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I remember seeing a guy creeping down the street who resembled my nightmare version of Charlie Chop-off. He looked at me funny, and I took off running. Whenever I sensed danger, I’d walk or run on the street side of the cars until I felt safe again, like playing high-stakes tag with a base out there, or swimming by sharks to a raft. Our block was relatively safe, but right there on Broadway and Seventy-Third was Needle Park, where the addicts hung out. They were brutal to see, the vacant look in their eyes, hands out, everything in a sort of warped slow motion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then in a minute’s walk were blocks of well-tended brownstones, new restaurants and cafés and even a few clubs. Up Broadway a little farther were beloved revival movie theaters—the Thalia and the Regency and the New Yorker—and bookstores, classic and metaphysical, head shops and hardware stores, bakeries and a traffic island bench with two nattily dressed Holocaust survivors sharing a bag of chestnuts, a greasy-haired man in a cable-knit sweater reading Henry Miller, a woman nearby selling paperbacks and LPs. The things you’d want in a city. Life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just before my stop, the woman on the other side of the peeing man whispered in my ear, “The world is full of terrible people.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db50e6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062258236_Chapter_2.vue
// module id = 78
// module chunks = 0